module.exports = __webpack_public_path__ + "img/NOT_EQUAL.e158ad98.svg";